import { render, staticRenderFns } from "./TaskManagement.vue?vue&type=template&id=972669d2"
import script from "./TaskManagement.vue?vue&type=script&lang=js"
export * from "./TaskManagement.vue?vue&type=script&lang=js"
import style0 from "./TaskManagement.vue?vue&type=style&index=0&id=972669d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports